import { z } from 'zod';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

const zodDecimalSchema = z.string().nullish();

export const zodLinkableDlnItemFiltersSchema = z.object({
  companyId: z.uuid().optional(),
  costCenterId: z.uuid().optional(),
  dateFrom: z.iso.date().optional(),
  dateTo: z.iso.date().optional(),
  searchString: z.string().trim().optional(),
  siteId: z.uuid().optional(),
});

export const zodLinkableDlnItemsQueryParamsSchema =
  zodLinkableDlnItemFiltersSchema.extend({
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().min(0).optional(),
  });

export const zodLinkableDlnItemsSelectionQueryParamsSchema =
  zodLinkableDlnItemFiltersSchema.extend({
    sameArticleNumberOnly: z.boolean().optional(),
  });

const zodLinkableDlnItemLinkSchema = z.object({
  linkId: z.uuid().nullish(),
  source: z.string(),
});

export const zodLinkableDlnItemSchema = z.object({
  companyId: z.uuid().nullish(),
  companyName: z.string().nullish(),
  deliveryDate: z.iso.date().nullish(),
  deliveryNoteId: z.uuid(),
  deliveryNoteNumber: z.string(),
  itemIndex: z.number().int(),
  link: zodLinkableDlnItemLinkSchema.nullish(),
  name: z.string().nullish(),
  position: z.string().nullish(),
  quantity: zodDecimalSchema,
  quantityInAdditionalUnit: zodDecimalSchema,
  quantityInLineUnit: zodDecimalSchema,
  sameArticleCount: z.number().int(),
  sellerAssignedId: z.string().nullish(),
  unit: z.string().nullish(),
  unitFits: z.boolean(),
  weight: zodDecimalSchema,
  weightUnit: z.string().nullish(),
});

export const zodLinkableDlnItemsResponseSchema = z.object({
  data: z.array(zodLinkableDlnItemSchema),
  deliveryNoteCount: z.number().int(),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int(),
  sameArticleNumberCount: z.number().int(),
  totalCount: z.number().int(),
});

export const zodDlnItemLinkTargetSchema = z.object({
  deliveryNoteId: z.uuid(),
  itemIndex: z.number().int().min(0),
});

export const zodLinkableDlnItemsSelectionSchema = z.object({
  additionalUnit: z.string().nullish(),
  count: z.number().int(),
  data: z.array(zodDlnItemLinkTargetSchema),
  totalAdditionalQuantity: zodDecimalSchema,
  totalQuantity: zodDecimalSchema,
  unit: z.string().nullish(),
});

export const zodDlnItemLinksEditPayloadSchema = z.object({
  add: z.array(zodDlnItemLinkTargetSchema.extend({ lineItemId: z.uuid() })),
  remove: z.array(z.object({ lineItemId: z.uuid(), linkId: z.uuid() })),
});

export const zodDlnItemLinksEditResultSchema = z.object({
  invoice: zodInvoiceDetailSchema,
  linkedCount: z.number().int(),
  removedCount: z.number().int(),
});
